import React, { useEffect, useRef, useState } from 'react'
import { Row, message } from 'antd'
import { YHRightModal } from '@/components/YHRightModal'
import { YhFormBox } from '@/components/YhFormBox'
import { getFormValidatorErrText } from "@/utils/utils"
import { IYhFormItemsBox, FormItemTypeEnum, IYhFormRef } from '@/components/YhFormBoxVertical/Types'
import { settleConfigModel } from '../settleConfigModel'
import { settleConfigService } from '../settleConfigService'
import { intentionService } from '@/views/join/intention/intentionService'
import { SettleConfigInsert, SettleConfigUpdate, SettleConfigDetail } from "../SettleConfigTypes";

export const Detail = () => {
    const {
        selectedRowKeys, mode,
        visible, setVisible,
        loadData, getOne,
        setFormInfo, getFormInfo,
        paymentMethod, setPaymentMethod,
    } = settleConfigModel()

    const formRef = useRef<IYhFormRef>()

    useEffect(() => {
        if (visible) {
            if (mode === 'edit') {
                getOne(mode, selectedRowKeys[0]);
            }
            else {
                setFormInfo(mode, undefined);
                setPaymentMethod(undefined);
            }
        }
    }, [visible])

    //监听批量录入字段
    const onChange = (changedValues: { [key: string]: SettleConfigDetail }) => {
        setFormInfo(mode, { ...getFormInfo(mode), ...changedValues });
    }

    const onCancel = () => {
        setVisible(false);
    }

    const onOk = async () => {
        formRef.current?.validateFields().then(val => {
            if (mode === 'edit') {
                settleConfigService.update({ ...val, id: selectedRowKeys[0] }).then(res => {
                    res && setVisible(false);
                    setFormInfo(mode, undefined);
                    loadData();
                    message.success("操作成功");
                })
            }
            else {
                settleConfigService.insert(val).then(res => {
                    res && setVisible(false);
                    setFormInfo(mode, undefined);
                    loadData();
                    message.success("操作成功");
                })
            }
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }

    //加盟商查询
    const franchiseeQuery = async (value) => {
        let params = {
            "searchItem": { "status": ["franchisee-status.initiated", "franchisee-status.completed", "franchisee-status.received"] },
            "pageSize": 15,
            "pageNum": 1,
            "orders": [{ "column": "createTime", "rule": "DESC" }]
        }

        return await intentionService.page(params).then((res) => {
            let results = res.retData.list
            if (results && results.length > 0) {
                return results.map((item) => ({
                    key: item.code ?? "",
                    id: item.code ?? "",
                    value: item.code ?? "",
                    label: item.name ?? "",
                }))
            } else {
                return [];
            }
        })
    }

    //加盟商名称
    const franchiseeChange = (value: string, option: any) => {
        if (option && value) {
            setFormInfo(mode, {
                ...getFormInfo(mode),
                franchiseeCode: value,
                franchiseeName: option.label,
            });
        }
    }

    const FormItem: IYhFormItemsBox = {
        title: '',
        style: { padding: '0 20px', marginBottom: '10px' },
        items: [
            {
                type: FormItemTypeEnum.AsyncSelect,
                fieldLabel: '请选择加盟商',
                fieldName: 'franchiseeCode',
                span: 24,
                rules: [{ required: true, message: '请选择加盟商' }],
                selectfetchList: franchiseeQuery,
                onSelectChange: franchiseeChange,
                defaultQuery: "%",
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '加盟商名称',
                fieldName: 'franchiseeName',
                span: 24,
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Radio,
                fieldLabel: '选择结算方式',
                fieldName: 'paymentMethod',
                span: 24,
                rules: [{ required: true, message: '请选择结算方式' }],
                onSelectChange: (e, op) => { setPaymentMethod(e); },
                radioDs: [{ label: "每月固定日期结算", value: "settlement_cyle_payment_method_regular" }, { label: "周期结算", value: "settlement_cyle_payment_method_cyle" }]
            },
            {
                type: FormItemTypeEnum.Radio,
                fieldLabel: '选择结算类型',
                fieldName: 'settlementType',
                span: 24,
                rules: [{ required: true, message: '请选择结算方式' }],
                radioDs: [{ label: "按单结算", value: "settlement_cyle_type_order" }, { label: "按金额结算", value: "settlement_cyle_type_amount" }]
            },
            {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "上次结算日期",
                fieldName: "lastSettlementTime",
                disable: mode === "add" ? false : true,
                span: 24,
            },
            paymentMethod === "settlement_cyle_payment_method_regular" ? {
                type: FormItemTypeEnum.Input,
                fieldLabel: '固定结算日期',
                fieldName: 'fixedTime',
                labelCol: { span: 6 },
                span: 24,
                rules: [{ required: true, message: '请输入固定结算日期' }],
                placeholder: '请输入固定结算日期',
                addonAfter: '日',
            } : {
                type: FormItemTypeEnum.Input,
                fieldLabel: '结算周期',
                fieldName: 'settlementCycleData',
                labelCol: { span: 6 },
                span: 24,
                rules: [{ required: true, message: '请输入结算周期' }],
                placeholder: '请输入结算周期',
                addonAfter: '天',
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '账单通知日期',
                fieldName: 'notificationTime',
                labelCol: { span: 6 },
                span: 24,
                rules: [{ required: true, message: '请输入账单通知日期' }],
                placeholder: '请输入账单通知日期',
                addonAfter: '日',
            },
            // {
            //     type: FormItemTypeEnum.Radio,
            //     fieldLabel: '维修属性',
            //     fieldName: 'repairAttribute',
            //     span: 24,
            //     rules: [{ required: true, message: '请选择维修属性' }],
            //     radioDs: [{ label: "国产", value: "国产" }, { label: "进口", value: "进口" }]
            // },
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: '工时比例',
            //     fieldName: 'workMarkupRate',
            //     labelCol: { span: 6 },
            //     span: 24,
            //     rules: [{ required: true, message: '请输入工时比例' }],
            //     placeholder: '请输入工时比例',
            // },
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: '配件比例',
            //     fieldName: 'accessoryMarkupRate',
            //     labelCol: { span: 6 },
            //     span: 24,
            //     rules: [{ required: true, message: '请输入配件比例' }],
            //     placeholder: '请输入配件比例',
            // },
        ]
    }
    const formConfig: any = {
        labelCol: { span: 6 },
        labelAlign: 'left',
        formRef,
        formValues: getFormInfo(mode),
        onChange,
        boxs: [FormItem],
    }
    return (
        <YHRightModal visible={visible} onOk={onOk} onCancel={onCancel} title="结算设置" width={600} bodyHeight={700} showFooter={true}>
            <Row>
                <YhFormBox {...formConfig} />
            </Row>
        </YHRightModal>
    )
}
